import { useContext } from 'react'
import { DrawerContext } from 'context/drawer'

export const useDrawerContext = () => useContext(DrawerContext)
